import { useState, useEffect } from 'react';
import { isMobile } from '../../../utils/utils';

const useHook = () => {

  const [mobile, setMobile] = useState(true);

  useEffect(() => {
    setMobile(isMobile());
  }, []);

  return {
    mobile,
  };
};

export default useHook;
